export const resolveSnomedLink = (snomedId) => {
    return `https://browser.ihtsdotools.org/?perspective=full&conceptId1=${snomedId}&edition=MAIN/2024-02-01&release=&languages=en`;
};
export const resolveLoincLink = (loincId) => {
    return `https://loinc.org/search/?t=1&s=${loincId}`;
};
export const resolveCPTNav = (code) => {
    return `https://www.aapc.com/codes/cpt-codes/${code}`;
};
export const resolveIcdCode = (icdCode) => {
    return `https://www.aapc.com/codes/icd-10-codes/${icdCode}`;
};
export const resolveRxNav = (type, code) => {
    return `https://mor.nlm.nih.gov/RxNav/search?searchBy=${type}&searchTerm=${code}`;
};
//# sourceMappingURL=link-resolvers.js.map